import * as types from './mutation_types'

export default {
  [types.AUTH_AUTHENTICATED] (state, authData) {
    state.authenticated = true
    state.accessToken = authData.accessToken
    state.idToken = authData.idToken
    state.expiresAt = authData.expiresIn * 1000 + new Date().getTime()
    state.profile = authData.idTokenPayload

    localStorage.setItem('access_token', state.accessToken)
    localStorage.setItem('id_token', state.idToken)
    localStorage.setItem('expires_at', state.expiresAt)
    localStorage.setItem('profile', JSON.stringify(state.profile))
  },

  [types.AUTH_LOGOUT] (state) {
    state.authenticated = false
    state.accessToken = null
    state.idToken = false
    state.expiresAt = null
    state.profile = null

    localStorage.removeItem('access_token')
    localStorage.removeItem('id_token')
    localStorage.removeItem('expires_at')
    localStorage.removeItem('profile')
  },

  [types.UPDATE_TOKEN] (state, authData) {
    state.authenticated = true
    state.accessToken = authData.accessToken
    state.idToken = authData.idToken
    state.expiresAt = authData.expiresIn * 1000 + new Date().getTime()

    localStorage.setItem('access_token', state.accessToken)
    localStorage.setItem('id_token', state.idToken)
    localStorage.setItem('expires_at', state.expiresAt)
  }
}
